<template>
  <Tooltip
    top
    :analytics-name="tooltipAnalyticsName"
    :analytics-params="tooltipAnalyticsParams"
    :color="tooltipColor"
  >
    <template #default="{ attrs, on }">
      <VChip
        v-if="label"
        x-small
        :color="color"
        text-color="white"
        label
        :class="['pl-2', 'mr-2', { 'ml-2': right }]"
        v-bind="attrs"
        v-on="on"
      >
        {{ label }}
        <VIcon
          x-small
          color="white"
          :left="label === null && left"
          :right="label !== null || right"
        >
          {{ icon }}
        </VIcon>
      </VChip>
      <!-- If there's no label, only show an icon -->
      <VIcon
        v-else
        x-small
        :color="color"
        :left="left"
        :right="right"
        v-bind="attrs"
        v-on="on"
      >
        {{ icon }}
      </VIcon>
    </template>
    <template #tooltip>
      <slot />
    </template>
  </Tooltip>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import { TooltipParams } from '@/components/mixins/analytics'
import { iconValidator } from '@/components/mixins/icons'
import Tooltip from '@/components/Tooltip.vue'

export default defineComponent({
  components: {
    Tooltip
  },
  props: {
    icon: {
      type: String,
      required: true,
      validator: iconValidator
    },
    color: {
      type: String as PropType<string | null>,
      default: null
    },
    right: {
      type: Boolean
    },
    label: {
      type: [String, Number] as PropType<string | number | null>,
      default: null
    },
    tooltipAnalyticsName: {
      type: String,
      default: 'IconWithTooltip'
    },
    tooltipColor: {
      type: String as PropType<string | undefined>,
      default: undefined
    }
  },
  setup({ icon, color, right }) {
    const tooltipAnalyticsParams: TooltipParams = {
      icon,
      // Only add if defined
      ...(color ? { color } : {})
    }
    return {
      tooltipAnalyticsParams,
      left: !right
    }
  }
})
</script>
